import { render, staticRenderFns } from "./CallTableSmsLogsActions.vue?vue&type=template&id=1b354baa"
import script from "./CallTableSmsLogsActions.vue?vue&type=script&lang=js"
export * from "./CallTableSmsLogsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports